module.exports = __webpack_public_path__ + "img/divider-bg.67d2ad32.jpg";